export default __webpack_public_path__ + "static/media/drive.fa5137d7.svg";